<template>
	<el-container>
		<el-header>
			<NavBar :navItems="navItems" :currentIndex="currentIndex" @changeTab="changeTab"></NavBar>
			<!-- {{deltaY}} - {{currentIndex}} - {{pageChangeCount}} -->
		</el-header>
		<el-main class="page-content">
			<el-carousel ref="carouselMain" :initial-index="currentIndex" direction="vertical" :autoplay="false" :loop="false"
				arrow="never" indicator-position="none" @setActiveItem="setActiveItem">
			  <el-carousel-item v-for="(component,index) in components" :key="index">
				<component :is="component" :isShowBack="isShowBack" :subActiveIndex="subActiveIndex"></component>
				<!-- <img :src="component.fImg" class="fotImg"/> -->
			  </el-carousel-item>
			</el-carousel>
			<a href="https://beian.miit.gov.cn/" target="_blank">
				<img src="../../static/footer-w.png" class="fotImg" v-if="currentIndex==-1 || currentIndex==0 "/>
			</a>
		</el-main>
		<RightMenu :isShowBack="isShowBack" @closePage="closePage"></RightMenu>
	</el-container>
	
</template>

<script>
	import { eventBus } from '@/main.js'
	import {mapActions, mapState} from 'vuex' //注册 action 和 state
	// import com from '../components/LeftMenu.vue'
	export default {
		name: 'App',
		components: {
			// ../../components/NavBar
			NavBar:() => import('@/components/Navbar.vue'),
			Home: () => import('./Home.vue'),
			Product: () => import('./Product.vue'),
			ProductSecond: () => import('./ProductSecond.vue'),
			Information: () => import('./Information.vue'),
			Kingstron: () => import('./Kingstron.vue'),
			Contact: () => import('./Contact.vue'),
			LeftMenu: () => import('../components/LeftMenu.vue'),
			RightMenu: () => import('../components/RightMenu.vue'),
		},
		data() {
			return {
				map:{},
				tmpRouter:"",
				navItems: [{
						label: '首页',
						componentName: 'home'
					},
					{
						label: '产品中心',
						componentName: 'product',
						subMenus:[{
							title:"人工生物心脏瓣膜",
							routerUrl:"productSecond/0"
						},{
							title:"瓣膜成形环",
							routerUrl:"productSecond/1"
						},{
							title:"心脏外科生物补片",
							routerUrl:"productSecond/2"
						},{
							title:"经导管主动脉瓣膜系统",
							routerUrl:"productSecond/3"
						}]
					},
					{
						label: '资讯中心',
						componentName: 'information',
						subMenus:[{
							title:"公司新闻",
							routerUrl:"information/0"
						},{
							title:"科普知识",
							routerUrl:"information/1"
						},{
							title:"临床病例",
							routerUrl:"information/2"
						}]
					},
					{
						label: '金仕生物',
						componentName: 'kingstron',
						subMenus:[{
							title:"公司介绍",
							routerUrl:"kingstronSecond/0"
						},{
							title:"企业文化",
							routerUrl:"kingstronSecond/1"
						}]
					},
					{
						label: '关于我们',
						componentName: 'contact',
						subMenus:[{
							title:"团队介绍",
							routerUrl:"contactSecond/0"
						},{
							title:"招贤纳士",
							routerUrl:"contactSecond/1"
						},{
							title:"联系我们",
							routerUrl:"contactSecond/2"
						}]
					}
				],
				components: ['Home', 'Product', 'Information', 'Kingstron', 'Contact'],
				navbar: ['首页', '产品中心', '资讯中心', '金仕生物', '关于我们'],
				currentIndex: 3,
				deltaY: null,
				lastScrollTime: 0,
				pageChanging: false,
				pageChangeTime: null,
				isShowBack: false,//二级页面返回按钮
				subActiveIndex: 0 //导航目录下拉菜单索引
			}
		},
		methods: {
			changeComponent(index) {
				if (!this.$store.state.isListening) {
					return;
				}
				// 检查当前平台是否为 Mac
				const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
				
				const currentTime = new Date().getTime();
				if (currentTime - this.lastScrollTime < 1500 && isMac) {
					console.log('mac scroll')
				    return;
				}
				this.lastScrollTime = currentTime;
				if (typeof index === 'number') {
					this.currentIndex = index
				} else {
					this.deltaY = Math.abs(index.deltaY)
					const delta = index.deltaY < 0 ? -1 : 1
					this.currentIndex = Math.max(0, Math.min(this.components.length - 1, this.currentIndex + delta))
					this.tmpRouter = '/'+this.components[this.currentIndex];
					if(this.$router.currentRoute.path == this.tmpRouter) return;
					this.$router.replace({
						path: '/'+this.components[this.currentIndex]
					})
					this.setActiveItem(this.currentIndex);
				}
			},
			changeTab(name){
				var pathName = name.substr(1,name.length);
				this.currentIndex = this.navItems.findIndex(item => item.componentName === pathName);
				this.setActiveItem(this.currentIndex);
			},
			setActiveItem(index) {
				this.$refs.carouselMain.setActiveItem(index);
			},
			resize: function() {
				var body = document.getElementsByTagName("body")[0];
				var html = document.getElementsByTagName("html")[0];
				var width = html.clientWidth;
				var height = html.clientHeight;
				var max = width > height ? width : height;
				var min = width > height ? height : width;
				body.style.width = max + "px";
				body.style.height = min + "px";
				// console.log(max, min);
			},
			closePage(){
				this.isShowBack = false;
			},
		},
		created() {
			eventBus.$on('leftMenuClick', (index) => {
				this.currentIndex = index;
				this.setActiveItem(index);
			});
			
		},
		watch:{
			$route(to,from){
				
				var index= this.navItems.findIndex((item)=>item.componentName==to.name)
				this.isShowBack = index >= 0 ? false : true;
			},
			isShowBack(val){
				this.isShowBack = val;
			},
			"$root.subMenuIndex":{
				handler(newVal,oldVal){
					this.subActiveIndex = newVal;
				}
			}
		},
		mounted() {
			const that = this;
			window.onresize = that.resize;
			window.addEventListener('wheel', this.changeComponent, { passive: true });
			window.addEventListener('refresh',this.changeTab('/'+that.$route.name))
		},
		destroyed() {
			window.removeEventListener('wheel', this.changeComponent)
		}
	}
</script>

<style lang="less">
	// @import url('../assets/css/index.less');
	@import '../assets/css/index';
	@import '../assets/css/style';
	@import '../assets/css/reset';
	// and (max-aspect-ratio: ~"29/4")
	@media only screen and (min-aspect-ratio: ~'1920/1080'){
	  .el-container {
	    width: 100%;
	    height: 100%;
	  }
	}
	/*移动端页面适配*/
	// @media only screen and (min-aspect-ratio: ~'1334/600'){
	// 	.mb-box{
	// 		transform: scale(0.85);
	//     position: relative;
	//   }
	// }
	// @media screen and (min-aspect-ratio: ~"192/108"){
	// 	.el-container {
	// 	  margin: 0 auto;
	// 	  width: 1920/@r;
	// 	  height: 1080/@r;
	// 	  border: 1px solid green;
	// 	}
	// }
	@media screen and (min-width: 1920px) {
	  .el-container {
	    margin: 50/@r auto;
	    width: 1920/@r;
	    height: 1080/@r;
		// border: 1px solid green;
	  }
	}
	.el-container {
		position: relative;
		// max-width: 1920px;
		margin: 0 auto;
		// width: 1680/@r;
		width: 1920/@r;
		height: 1080/@r;
		overflow: hidden;
	}
	.el-main{
		width: 1680/@r;
		height: 967/@r;
		margin: 0 auto;
		overflow: hidden !important;
	}
	.el-carousel,.el-carousel__container{
		height: 100% !important;
	}
	.el-carousel__indicators{
		left: 0;
	}
	.el-header{
		height: 113/@r !important;
	}
	// .logo {
	// 	margin-right: 0;
	// 	position: absolute;
	// 	right: 0;
	// 	top: 0;
	// 	width: 200/@r;
	// 	height: 40/@r;
	// }
	.page-content {
		position: relative;
		// width: 100%;
		// height: 90%;
		width: 1680/@r;
		height: 967/@r;
	}
	.fotImg{
		position: absolute;
		left: 52/@r;
		bottom: 52/@r;
		width: 458/@r;
		height: 13/@r;
		z-index: 9;
	}
</style>
